import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    eventLabel: String,
    companyId: String
  }

  connect() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    fetch('/member_company_event_stats', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken },
      body: JSON.stringify({ event_label: this.eventLabelValue, company_id: this.companyIdValue })
    });
  }
}
